import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import ScrollTop from './../../User/ScrollTop';
import WhatsAppIcon from './../../User/WhatsAppIcon';
import GlobalEnquiryIcon from './../../User/GlobalEnquiryIcon';

const UserLayout = () => {
  return (
    <div className="min-h-screen flex flex-col">
      {/* Fixed Header */}
      <div className="fixed top-0 left-0 right-0 z-50">
        <Header />
      </div>
      
      {/* Main Content with padding to account for fixed header */}
      <main className="flex-grow pt-[76px]">
        <Outlet />
      </main>
      
      {/* Footer */}
      <Footer />
       <GlobalEnquiryIcon/>
       <WhatsAppIcon/>
      <ScrollTop/>
    </div>
  );
};

export default UserLayout;